export default class EntityService {
  constructor($http, appConfig) {
    "ngInject";

    this._$http = $http;
    this._appConfig = appConfig
  }

  listEntitiesOld(entityType, entityId) {
    return this._$http.get(this._appConfig.apiServiceBaseUri + 'api/entity/list/' + entityType + '/' + entityId);
  }

  addEntity(entity) {
    return this._$http.post(this._appConfig.apiServiceBaseUri + 'api/entity/add', entity);
  }

  addUser(user) {
    return this._$http.post(this._appConfig.apiServiceBaseUri + 'api/user/add', user);
  }

  getEntity(entityId) {
    return this._$http.get(this._appConfig.apiServiceBaseUri + `api/entity/get/${entityId}`);
  }

  listEntities(filterParams, pageStart, pageSize) {
    let query = `?pageStart=${pageStart}&itemsToFetch=${pageSize}`;

    if (filterParams && filterParams.name) {
      query += `&name=${filterParams.name}`;
    }

    if (filterParams && filterParams.entityType) {
      query += `&entityType=${filterParams.entityType}`;
    }

    if (filterParams && filterParams.brandType) {
      query += `&brandType=${filterParams.brandType}`;
    }    

    if (filterParams && filterParams.state) {
      query += `&state=${filterParams.state}`;
    }

    if (filterParams && filterParams.sortExpression) {
      query += `&sortExpression=${filterParams.sortExpression}&ascending=${filterParams.ascending}`;
    }

    return this._$http.get(this._appConfig.apiServiceBaseUri + 'api/entity/list' + query);
  }

  updateEntityState(entityId, state) {
    return this._$http.get(this._appConfig.apiServiceBaseUri + `api/entity/update/${entityId}/${state}`);
  }

  updateUserPreferences(userPreferences) {
    return this._$http.post(this._appConfig.apiServiceBaseUri + `api/entity/updateuserpref/`, userPreferences);
  }  

  listAllLocations() {
    return this._$http.get(this._appConfig.apiServiceBaseUri + `api/entity/listalllocations`);
  } 

  listAllImportLocations() {
    return this._$http.get(this._appConfig.apiServiceBaseUri + `api/entity/listallimportlocations`);
  } 

  getEntityPreferences(entityId) {
    return this._$http.get(this._appConfig.apiServiceBaseUri + `api/entity/getentitypreferences/${entityId}`);
  } 

  updateEntityPreferences(entityPrefs) {
    return this._$http.post(this._appConfig.apiServiceBaseUri + `api/entity/updateentitypreferences`, entityPrefs);
  } 
  
  getEntityReportsAccess(entityId) {
    return this._$http.get(this._appConfig.apiServiceBaseUri + `api/entity/getentityreportsaccess/${entityId}`);
  }   

  toggleEntityReportAccess(entityId, reportId) {
    return this._$http.get(this._appConfig.apiServiceBaseUri + `api/entity/toggleentityreportaccess/${entityId}/${reportId}`);
  }     

  updateStockProvider(stockProviderViewModel) {
    return this._$http.post(this._appConfig.apiServiceBaseUri + `api/entity/updatestockprovider/`, stockProviderViewModel);
  }       
}



// WEBPACK FOOTER //
// ./client/app/components/admin/entity/entity.service.js